import htmx from "htmx.org";
import "idiomorph/htmx";

declare global {
	interface Window {
		htmx: typeof htmx;
	}
}

htmx.config.globalViewTransitions = true;
htmx.config.refreshOnHistoryMiss = true;
htmx.config.scrollBehavior = "smooth";
htmx.config.scrollIntoViewOnBoost = false;

window.htmx = htmx;
